<script setup>

import { defineProps, defineEmits, ref, computed} from "vue";
import ItemLinhaMostragem from "./ItemLinhaMostragem.vue";
import ItemLinhaPreenchimento from "./ItemLinhaPreenchimento.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "revisandoPedido",
    "pedidoDeCompra",
    "item",
    "itensUnidades",
    "controlesDesativados",
]);

const emits = defineEmits([
    "update:itens",
    "update:item",
    "update:removeItem",
]);

//==================================================================//
//====================== Item Linha Mostragem ======================//
//==================================================================//

const itemLinhaMostragem = ref(null);

//==================================================================//
//===================== Item Linha Preenchimento ===================//
//==================================================================//

const itemLinhaPreenchimento = ref(null);

//==================================================================//
//========================== Altera Itens ==========================//
//==================================================================//

const alteraItens = (update = {}) =>{

    emits('update:itens', update);

};

//==================================================================//
//=========================== Altera Item ==========================//
//==================================================================//

const alteraItem = (update = {}) =>{

    update.id = props?.item?.id;
    emits('update:item', update);

};

//==================================================================//
//=========================== Remove Item ==========================//
//==================================================================//

const removeItem = (update = {}) =>{

    emits('update:removeItem', update);

};

//==================================================================//
//=========================== Parcela Tipo =========================//
//==================================================================//

const itemTipo = computed(()=>{

    if(props?.item?.status == "Leitura"){
        return "Leitura"
    }

    if(props?.item?.novo == true){
        return "Novo"
    }

    return "Rascunho";

});

</script>

<template>

    <div class="c-item">

        <ItemLinhaMostragem
            ref="itemLinhaMostragem"
            :revisandoPedido="props.revisandoPedido"
            :pedidoDeCompra="props.pedidoDeCompra"
            :item="props.item"
            :itemTipo="itemTipo"
            :controlesDesativados="props.controlesDesativados"
            @update:item="alteraItem"
            @update:removeItem="removeItem"
        ></ItemLinhaMostragem>

        <ItemLinhaPreenchimento
            ref="itemLinhaPreenchimento"
            :revisandoPedido="props.revisandoPedido"
            :pedidoDeCompra="props.pedidoDeCompra"
            :item="props.item"
            :itemTipo="itemTipo"
            :itensUnidades="props.itensUnidades"
            :controlesDesativados="props.controlesDesativados"
            @update:item="alteraItem"
            @update:itens="alteraItens"
        ></ItemLinhaPreenchimento>

    </div>

</template>

<style>

.c-item{
    display: contents;
}

</style>